import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/lib/services/common-service'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client';
import { ConfigInfo, ConfigUpdateRequest } from 'src/lib/entity/remote-config';
import { minimumSupportedIosVersion, minimumSupportedAndroidVersion, androidSoftwareDecoderModelList, changeBroadcastTargetDelayTimeSec, isAwsMode } from 'src/lib/entity/remote-config';

@Component({
  selector: 'config-create',
  templateUrl: './config-create.component.html',
  styleUrls: ['./config-create.component.scss', '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss']
})
export class ConfigCreateComponent implements OnInit {
  
  configInfo: ConfigInfo;

  editConfigInfo1: minimumSupportedIosVersion;
  editConfigInfo2: minimumSupportedAndroidVersion;
  editConfigInfo3: androidSoftwareDecoderModelList;
  editConfigInfo4: changeBroadcastTargetDelayTimeSec;
  editConfigInfo5: isAwsMode;

  constructor(
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.commonService.configSetting.subscribe(data => {
      this.configInfo = data;
    });
    this.editConfigInfo1 = this.configInfo.configInfo1
    this.editConfigInfo2 = this.configInfo.configInfo2 
    this.editConfigInfo3 = this.configInfo.configInfo3
    this.editConfigInfo4 = this.configInfo.configInfo4
    this.editConfigInfo5 = this.configInfo.configInfo5

    if (this.editConfigInfo3.length === 0) {
      this.editConfigInfo3.push('');
    }
  }

  // 参照データ登録
  public configUpdate() {
    let params: ConfigUpdateRequest = {
      minimumSupportedIosVersion: this.editConfigInfo1,
      minimumSupportedAndroidVersion: this.editConfigInfo2,
      androidSoftwareDecoderModelList: this.editConfigInfo3.filter(list => list.trim()),
      changeBroadcastTargetDelayTimeSec: this.editConfigInfo4,
      isAwsMode: this.editConfigInfo5
    };
    MagliveApiClient.updateConfigInfo(params).subscribe();
  }

  public configCancel() {
    this.router.navigate(['admin/config'], { relativeTo: this.route });
  }

  public trackBy(index: number, obj: any): any {
    return index;
  }

  public addArray(type: number) {
    if (type === 1) {
      this.editConfigInfo3.push('');
    }
  }

}
